<div class="customer-info-form-container">
  <div class="customer-info-form">
    <div class="body">

      @if (this.isModal){
      <!-- COLONNE 1 -->
      <div class="customer-info-form-column">
        <div class="common-form-container">
          <!-- Titre identification -->
          <div class="header">
            <span [innerHTML]="'customer-info-form.login-form.title' | translate"></span>
          </div>

          <!-- Email -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label3' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <p-inputGroup>
                  <input
                    class="text-input sentry-mask"
                    type="text"
                    pInputText
                    [(ngModel)]="inputs.email.value"
                    name="input-signup-email"
                    id="input-signup-email"
                    [placeholder]="'popins.signup.label3' | translate"
                    (blur)="validateEmail()" />
                  <p-inputGroupAddon>
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                  </p-inputGroupAddon>
                </p-inputGroup>
              </div>
              <div *ngIf="inputs.email.validated && inputs.email.error" class="error-message">
                {{ 'popins.signup.errors.emailFormat' | translate }}
              </div>
            </div>
          </div>

          <!-- Confirmer Email -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label4' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  [(ngModel)]="inputs.confirmeEmail.value"
                  name="input-signup-confirm-email"
                  id="input-signup-confirm-email"
                  (blur)="validateConfirmEmail()" />
              </div>
              <div *ngIf="inputs.confirmeEmail.validated && inputs.confirmeEmail.error" class="error-message">
                {{ 'popins.signup.errors.emailConfirm' | translate }}
              </div>
            </div>
          </div>

          <!-- Mot de passe -->
          @if (!isVendor) {
            <div class="input-row">
              <div class="form-input">
                <div class="label-row">
                  <span class="label">{{ 'popins.signup.label5' | translate }}</span
                  ><span class="required">*</span>
                </div>
                <div class="input">
                  <p-inputGroup>
                    <input
                      class="text-input sentry-mask"
                      [type]="passwordVisible ? 'text' : 'password'"
                      pInputText
                      [(ngModel)]="inputs.password.value"
                      name="input-signup-password"
                      id="input-signup-password" />
                    <p-inputGroupAddon (click)="passwordVisible = !passwordVisible" [ngStyle]="{'cursor': 'pointer'}">
                      <fa-icon [icon]="passwordVisible ? faEyeSlash : faEye"></fa-icon>
                    </p-inputGroupAddon>
                  </p-inputGroup>
                </div>
                <!-- Check password -->
                <div class="password-check mt-2">
                  <small>
                    Votre mot de passe doit contenir :
                    <span
                      [ngClass]="{
                        'text-success': checkIfPasswordContainLowercase(),
                        'text-danger': !checkIfPasswordContainLowercase(),
                      }"
                      >une minuscule</span
                    >,
                    <span
                      [ngClass]="{
                        'text-success': checkIfPasswordContainUppercase(),
                        'text-danger': !checkIfPasswordContainUppercase(),
                      }"
                      >une majuscule</span
                    >,<br />
                    <span
                      [ngClass]="{
                        'text-success': checkIfPasswordContainNumber(),
                        'text-danger': !checkIfPasswordContainNumber(),
                      }"
                      >un chiffre</span
                    >,
                    <span
                      [ngClass]="{
                        'text-success': checkIfPasswordContainSpecialCharacter(),
                        'text-danger': !checkIfPasswordContainSpecialCharacter(),
                      }"
                      >un caractère spécial (&#64;$!%*?&)</span
                    >
                    et au moins
                    <span
                      [ngClass]="{
                        'text-success': checkIfPasswordHasMinLength(),
                        'text-danger': !checkIfPasswordHasMinLength(),
                      }"
                      >13 caractères</span
                    >.
                  </small>
                </div>
              </div>
            </div>

            <!-- Confirmer mot de passe -->
            <div class="input-row">
              <div class="form-input">
                <div class="label-row">
                  <span class="label">{{ 'popins.signup.label6' | translate }}</span
                  ><span class="required">*</span>
                </div>
                <div class="input">
                  <p-inputGroup>
                    <input
                      class="text-input sentry-mask"
                      [type]="confirmPasswordVisible ? 'text' : 'password'"
                      pInputText
                      [(ngModel)]="inputs.confirmePassword.value"
                      name="input-signup-confirm-password"
                      id="input-signup-confirm-password"
                      (blur)="validateConfirmPassword()" />
                    <p-inputGroupAddon
                      (click)="confirmPasswordVisible = !confirmPasswordVisible"
                      [ngStyle]="{'cursor': 'pointer'}">
                      <fa-icon [icon]="confirmPasswordVisible ? faEyeSlash : faEye"></fa-icon>
                    </p-inputGroupAddon>
                  </p-inputGroup>
                </div>
                <div *ngIf="inputs.confirmePassword.validated && inputs.confirmePassword.error" class="error-message">
                  {{ 'popins.signup.errors.confirm_password' | translate }}
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      }

      <!-- COLONNE 2 -->
      <div class="customer-info-form-column">
        <div class="common-form-container">
          <!-- Titre civilité -->
          <div class="header">
            <span [innerHTML]="'customer-info-form.civility-form.title' | translate"></span>
          </div>

          <!-- Civilité -->
          <div class="input-row">
            <div class="form-input" #civility>
              <div class="label-row">
                <span class="label">{{ 'popins.signup.civility' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="radio-inputs sentry-mask">
                <div class="radio-option" *ngFor="let civilityValue of civilityValues">
                  <p-radioButton
                    [inputId]="civilityValue.value"
                    name="civility"
                    [(ngModel)]="inputs.civilite.value"
                    [value]="civilityValue.value" />
                  <label [for]="civilityValue.value">{{ civilityValue.name }}</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Nom -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label1' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  [(ngModel)]="inputs.nom.value"
                  name="input-signup-last-name"
                  id="input-signup-last-name" />
              </div>
            </div>
          </div>

          <!-- Prénom -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label2' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  [(ngModel)]="inputs.prenom.value"
                  name="input-signup-name"
                  id="input-signup-name" />
              </div>
            </div>
          </div>

          <!-- Téléphone -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.labelPhone' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  [(ngModel)]="inputs.telephone.value"
                  name="input-signup-phone"
                  id="input-signup-phone"
                  (blur)="validatePhone()" />
              </div>
              <div *ngIf="inputs.telephone.validated && inputs.telephone.error" class="error-message">
                {{ 'popins.signup.errors.phone' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- COLONNE 3 -->
      <div class="customer-info-form-column">
        <div class="common-form-container">
          <!-- Titre adresse -->
          <div class="header">
            <span [innerHTML]="'customer-info-form.address-form.title' | translate"></span>
          </div>

          <!-- Adresse -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label7' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  [(ngModel)]="inputs.adresse.value"
                  name="input-signup-adress"
                  id="input-signup-adress" />
              </div>
            </div>
          </div>

          <!-- Complément -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label8' | translate }}</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  [(ngModel)]="inputs.complement.value"
                  name="input-signup-adress-complement"
                  id="input-signup-adress-complement" />
              </div>
            </div>
          </div>

          <!-- Code postal / Ville -->
          <div class="input-row">
            <div class="form-input small">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label9' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  [(ngModel)]="inputs.codePostal.value"
                  name="input-signup-zipcode"
                  id="input-signup-zipcode"
                  (blur)="validatePostalCode()" />
              </div>
              <div *ngIf="inputs.codePostal.validated && inputs.codePostal.error" class="error-message">
                {{ 'popins.signup.errors.postalCode' | translate }}
              </div>
            </div>

            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label10' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input">
                <input
                  class="text-input sentry-mask"
                  type="text"
                  pInputText
                  [(ngModel)]="inputs.ville.value"
                  name="input-signup-city"
                  id="input-signup-city" />
              </div>
            </div>
          </div>

          <!-- Pays -->
          <div class="input-row">
            <div class="form-input">
              <div class="label-row">
                <span class="label">{{ 'popins.signup.label11' | translate }}</span
                ><span class="required">*</span>
              </div>
              <div class="input sentry-mask">
                <p-dropdown
                  [options]="countries"
                  [(ngModel)]="inputs.pays.value"
                  [ngClass]="{ error: inputs.pays.error }"
                  name="input-signup-state"
                  id="input-signup-state"
                  optionLabel="label"
                  [placeholder]="'popins.signup.label11' | translate">
                </p-dropdown>
              </div>
            </div>
          </div>

          <!-- Marketing Consent -->
          <div class="input-row">
            <div class="form-input">
              <div class="marketing-consent-form-container" [formGroup]="marketingConsentForm">
                <ng-casto-marketing-consent-selector [marketingConsentFormGroup]="marketingConsentForm">
                </ng-casto-marketing-consent-selector>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="footer">
      <div class="actions">
        <ng-casto-button
          class="secondary"
          *ngIf="showBackToLogin"
          (click)="login()"
          [label]="'popins.signup.link2' | translate">
        </ng-casto-button>
        <ng-casto-button
          class="primary"
          [loading]="isLoading"
          (click)="submit()"
          [label]="'popins.signup.btn' | translate"
          [disabled]="!isFormValid()">
        </ng-casto-button>
      </div>
    </div>
  </div>
</div>
